export default __webpack_public_path__ + "fonts/9ae353c18d418f067a70ba1e9a6a01d1.svg";